<template>
  <div class="gallery-section">
    <div @click="toggleMenu()" id="hamburger" class="hamburger hamburger--squeeze js-hamburger"
         :class="{ 'is-active' : menuOpen }">
      <div class="hamburger-box">
        <div class="hamburger-inner"></div>
      </div>
    </div>
    <div class="container mb-5">
      <div class="row">
        <div class="col-12 gallery-select-buttons-holder">
          <button @click="selected = 'photos'" class="gallery-select-button"
                  :class="{ 'active' : selected === 'photos' }">Foto
          </button>
          <button @click="selected = 'videos'" class="gallery-select-button"
                  :class="{ 'active' : selected === 'videos' }">Video
          </button>
        </div>
      </div>
    </div>
    <div v-show="selected === 'photos'" class="photos">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="gallery-title">Slike benda</h2>
          </div>
        </div>
      </div>
      <div class="container mb-5">
        <div class="row">
          <div class="col-12 gallery-holder">
            <div>
              <gallery :images="bandImages" :index="bandIndex" @close="bandIndex = null"></gallery>
              <div class="image"
                   v-for="(bandImage, bandImageIndex) in bandImages"
                   :key="bandImageIndex"
                   @click="bandIndex = bandImageIndex"
                   :style="{ backgroundImage: 'url(' + bandImage + ')', width: '300px', height: '150px' }"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="container">-->
        <!--<div class="row">-->
          <!--<div class="col-12">-->
            <!--<h2 class="gallery-title">Slike sa nastupa</h2>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
      <!--<div class="container mb-5">-->
        <!--<div class="row">-->
          <!--<div class="col-12 gallery-holder">-->
            <!--<div>-->
              <!--<gallery id="blueimp-gallery2" :images="images" :index="index" @close="index = null"></gallery>-->
              <!--<div class="image"-->
                   <!--v-for="(image, imageIndex) in images"-->
                   <!--:key="imageIndex"-->
                   <!--@click="index = imageIndex"-->
                   <!--:style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '150px' }"-->
              <!--&gt;</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    </div>
    <div v-show="selected === 'videos'" class="videos">
      <div class="container">
        <div class="row" style="margin-top: 70px;">
          <div class="col-12">
            <h2 class="gallery-title">Naši nastupi</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-4 video-col">
            <div class="top-video-holder">
              <div class="youtube" data-embed="estouJj_Rv4">
                <div class="play-button"></div>
              </div>
              <div class="top-video-holder-bottom">
                <h4>Samo se noćas pojavi...</h4>
              </div>
            </div>
          </div>
          <div class="col-4 video-col">
            <div class="top-video-holder">
              <div class="youtube" data-embed="jYYwKJMwnuI">
                <div class="play-button"></div>
              </div>
              <div class="top-video-holder-bottom">
                <h4>Volim osmeh tvoj...</h4>
              </div>
            </div>
          </div>
          <div class="col-4 video-col">
            <div class="top-video-holder">
              <div class="youtube" data-embed="zViSZCMewv4">
                <div class="play-button"></div>
              </div>
              <div class="top-video-holder-bottom">
                <h4>Lopov...</h4>
              </div>
            </div>
          </div>
          <div class="col-4 video-col">
            <div class="top-video-holder">
              <div class="youtube" data-embed="l6mWnOx509k">
                <div class="play-button"></div>
              </div>
              <div class="top-video-holder-bottom">
                <h4>Mix zabavne</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VueGallery from 'vue-gallery';
  import videos from '../assets/json/videos.json';

  export default {
    data: function () {
      return {
        menuOpen: false,
        videos,
        bandImages: [
          '/static/images/gallery/gal1.jpg',
          '/static/images/gallery/gal2.jpg',
          '/static/images/gallery/gal3.jpg',
          '/static/images/gallery/gal4.jpg',
          '/static/images/gallery/gal5.jpg'
        ],
        bandIndex: null,
        // images: [
        //   '/static/images/gallery/gal5.jpg',
        //   '/static/images/gallery/gal1.jpg',
        //   '/static/images/gallery/gal2.jpg',
        //   '/static/images/gallery/gal3.jpg',
        //   '/static/images/gallery/gal4.jpg'
        // ],
        // index: null,
        selected: 'photos',
      };
    },

    components: {
      'gallery': VueGallery
    },

    methods: {
      toggleNav() {
        this.menuOpen = !this.menuOpen;
      },
      closeNav() {
        this.menuOpen = false;
      },
      toggleMenu() {
        document.getElementById('header').classList.toggle('shown');
        document.getElementById('hamburger').classList.toggle('is-active');
      }
    },

    mounted() {
      let youtube = document.querySelectorAll(".youtube");
      for (let i = 0; i < youtube.length; i++) {
        // thumbnail image source
        let source = "https://img.youtube.com/vi/" + youtube[i].dataset.embed + "/hqdefault.jpg";

        // Load the image asynchronously
        let image = new Image();
        image.src = source;
        image.addEventListener("load", function () {
          youtube[i].appendChild(image);
        }(i));


        youtube[i].addEventListener("click", function () {

          let iframe = document.createElement("iframe");

          iframe.setAttribute("frameborder", "0");
          iframe.setAttribute("allowfullscreen", "");
          iframe.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.embed + "?rel=0&showinfo=0&autoplay=1");

          this.innerHTML = "";
          this.appendChild(iframe);
        });
      }
    }
  }
</script>

<style>
  .gallery-holder .image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    margin: 5px;
    width: calc(20% - 10px) !important;
  }

  @media (max-width: 768px) {
    .gallery-holder .image {
      width: calc(30% - 10px) !important;
      height: 100px !important;
    }
  }

  @media (max-width: 425px) {
    .gallery-holder .image {
      width: calc(50% - 10px) !important;
      height: 100px !important;
    }
  }

  #blueimp-gallery.blueimp-gallery.blueimp-gallery-controls > .close {
    color: #fff !important;
    opacity: 1 !important;
    text-shadow: none !important;
    font-size: 35px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/GallerySection.vue